export enum StaticDataType {
    INSTITUTE_TYPE,
    INSTITUTE_BENEFIT,
    EDUCATION_LEVEL,
	COURSE_DURATION,
	COURSE_CATEGORY,
	COURSE_DISCIPLINE,
	COURSE_INTAKE_STATUS,
	ENGLISH_EXAM_TYPE,
	GRADING_SCHEME,
	DOCUMENT_TYPE,
	DOCUMENT_TYPE_VISA_APPLICABLE,
	DOCUMENT_TYPE_PARTNER,
	DOCUMENT_TYPE_PARTNER_CERT,
	COURSE_APPL_STATUS,
	STUDENT_COURSE_APPLICATION_STATUS,
	PAYMENT_STATUS,
	REGION,
	ENGAGEMENT_LEVEL,
	GENDER,
	VISA_TYPE,
	LEAD_SOURCE,
	LEAD_STATUS,
	STUDENT_RESIDENTIAL_TYPE,
	STUDENT_DOMESTIC_RESIDENT_STATUS,
	STUDENT_INTERNATIONAL_RESIDENT_STATUS,
	STUDENT_TBD_RESIDENT_STATUS,
	SOURCE_OF_FEE,
	MARITAL_STATUS,
	ENGLISH_PROFICIENCY,
	DOCUMENT_PURPOSE,
	DOCUMENT_PURPOSE_TYPE_ADMISSION,
	DOCUMENT_PURPOSE_TYPE_ADMISSION_ID_PROOF,
	DOC_PURPOSE_TYPE_ADM_RESIDENTIAL_PROOF,
	COLLEGE_FORM_MODULE
}
